module.exports = __webpack_public_path__ + "img/IMG_9928_L_Foamcore_MockedUp.243dc646.jpg";